import Vue from 'vue'
import Vuex from 'vuex'
import pokemons from './modules/pokemons'
import dashboard from './modules/dashboard'
import userData from './modules/userdata'
import permissions from './modules/permissions'
import autocomplete from './modules/autocomplete'
import Inventory from './modules/inventory'
import Variables from './modules/variables'
import Tradelog from './modules/tradelog'
import PVPlog from './modules/pvplog'
import Auditlog from './modules/admin'
import Connections from './modules/connections'
import SystemBans from './modules/systembans'
import OnlineList from './modules/onlineList'
import Pokedex from './modules/pokedex'
import Requests from './modules/requests'
import News from './modules/news'
import GlobalVars from './modules/globalvars'
import UserHistory from './modules/userhistory'
import Chatlog from './modules/chatlog'
import Stats from './modules/stats'
import GuildHistory from './modules/guildhistory'
import Watchlist from './modules/watchlist'
import Playtime from './modules/playtime'
import Ladders from './modules/ladders'
import UserMails from './modules/mails'
import InfoTexts from './modules/infotexts'
import PvpBanlist from './modules/pvpbanlist'
import RandomSets from './modules/randomsets'
import VueNotifications from "vue-notifications";
import iziToast from "izitoast";
import processing from '@/store/modules/processing'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    pokemons,
    dashboard,
    userData,
    UserHistory,
    permissions,
    autocomplete,
    Inventory,
    Variables,
    Tradelog,
    Stats,
    Auditlog,
    Connections,
    SystemBans,
    OnlineList,
    Pokedex,
    Requests,
    GlobalVars,
    News,
    GuildHistory,
    Chatlog,
    Watchlist,
    Playtime,
    PVPlog,
    Ladders,
    PvpBanlist,
    RandomSets,
    UserMails,
    InfoTexts,
    processing
  },
  getters: {
    authUser: state => state.socket.user,
    loading: state => state.loading,
    isConnected: state => state.socket.isConnected,
    reconnecting: state => state.socket.reconnecting,
    authPending: state => state.socket.authPending,
    wasConnected: state => state.socket.wasConnected
  },
  state: {
    loading: false,
    socket: {
      isConnected: false,
      message: '',
      reconnecting: 0,
      reconnectError: false,
      user: null,
      authPending: false,
      wasConnected: false
    }
  },
  mutations: {
    SOCKET_ONOPEN (state, event) {
      console.log('SOCKET_ONOPEN')

      state.socket.isConnected = true
      state.socket.reconnecting = 0
    },
    SOCKET_ONCLOSE (state, event) {
      state.socket.isConnected = false
    },
    SOCKET_ONERROR (state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, message) {
      console.log('SOCKET_ONMESSAGE')

      state.message = message
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT (state, count) {
      state.socket.reconnecting = count
      state.socket.reconnectError = false
    },
    setAuth (state, auth) {
      state.socket.user = auth
    },
    setAuthPending (state, pending) {
      state.socket.authPending = pending
    },
    setWasConnected (state, wasConnected) {
      state.socket.wasConnected = wasConnected
    },
    setLoading (state, load) {
      state.loading = load
    }
  },
  actions: {
    setLoading ({ commit, data }) {
      commit('setLoading', data.data)
    },
    permission ({ commit }, message) {
      commit('setAuth', message.data)
      commit('setAuthPending', false)
    },
    sendSystemMessage({commit}, message) {
      commit('setLoading', false)
      iziToast[message.data.type]({
        title:  message.data.title,
        message: message.data.message,
      });
      },

    restartTools({commit}, message) {
      window.location.reload();
    },
    resetPermission ({ commit }) {
      commit('setAuth', null)
      commit('setAuthPending', false)
    },
    setAuthPending ({ commit }, pending) {
      commit('setAuthPending', pending)
    }

  }
})
